import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import  DBKText from '@dbk/ui-text';
import Text from '../../../common/text';
import { PALETTE } from '../../../../constants';
import styles from '../validation-pasword.styles';
import { testIDProps } from '../../../../../src/common/components/utils/with-automation-id-props'
import { SuccessIcon } from '../../../common/icons/index';

const successTickColor = PALETTE.successIcon;

function ValidationLabelPassword({ error, title, testID,showTick }) {
 

  if (showTick === true ) {
    let testID_Valid = testID+'_Valid';
    return (
      <View {...testIDProps(testID)} style={styles.root}>
        <SuccessIcon {...testIDProps(testID_Valid)} color={successTickColor} height={24} width={24}/>
        <DBKText
         className="margin-left-10 margin-bottom-10"
        >
          {title}
        </DBKText>
      </View>
    );
  }
  if (showTick === false ) {
    let testID_InValid = testID+'_InValid';
    return (
      <View {...testIDProps(testID)} style={styles.root}> 
        <DBKText className="margin-bottom-10" >
          {title}
        </DBKText>
      </View>
    );
  }

  
  return (
    <View {...testIDProps(testID)} style={styles.root}> 
      <DBKText className="margin-bottom-10">
        {title}
      </DBKText>
    </View>
  );
}

ValidationLabelPassword.propTypes = {
  error: PropTypes.bool,
  title: PropTypes.string,
  testID: PropTypes.string,
  showTick :PropTypes.bool,
};

export default ValidationLabelPassword;
